import React, { useEffect, useState, useRef } from "react";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import "../../assets/css/inbox.css";
import "../../assets/css/style.css";
import "../../assets/css/responsive.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Logo from "../../assets/images/TKC-Logo1.png";
import LogoPw from "../../assets/images/Logo.png";
import Spinner from "../../components/Spinner";
import { useLocation, useNavigate, useParams } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const WelcomePage = (props) => {
  const params = useParams();
  console.log(params.tempid);
  const location = useLocation();
  console.log(location);
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [contact, setContact] = useState("");
  const [name, setName] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const [isVerify, setIsVerify] = useState(true);
  useEffect(() => {
    getCandidateData();
  }, []);
  async function getCandidateData() {
    setLoader(true);
    const obj = {
      intervieweeid: params.id,
      template_id: params?.tempid !== undefined ? params?.tempid : 0,
    };
    await ApiHelper.post(API.getApplicantsbyId, obj)
      .then((resData) => {
        if (resData.data.success === true) {
          setContact(resData.data?.interview_data?.phone);
          setName(resData.data?.interview_data?.first_name);
          setCompanyLogo(resData?.data?.companyLogo);
          setIsVerify(
            resData?.data?.interview_data?.fullchatbot?.send_otp === 1
              ? true
              : false
          );
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }
  async function sendVerification() {
    setLoader(true);
    const obj = {
      intervieweeid: params.id,
    };
    await ApiHelper.post(API.sendVerification, obj)
      .then((resData) => {
        if (resData.data.success === true) {
          toast(resData.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "success",
          });
          params?.tempid !== undefined
            ? navigate("/otp-verification/" + params.id + "/" + params.tempid)
            : navigate("/otp-verification/" + params.id);
          setLoader(false);
        } else {
          setLoader(false);
          toast(resData.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "error",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }
  return (
    <div>
      <div className="fixHeader candPrv">
        <div className="row">
          <div className="w-100 logo-sec">
            <div className="logoCent logo-sec">
              {companyLogo !== null && (
                <img
                  src={API.avenuView + companyLogo}
                  alt="logo"
                  className="logo-inner mb-0 me-2"
                />
              )}
            </div>
            <div className="logoSide logo-sec">
              <p className="Powered-by-text">Powered by</p>
              <img src={LogoPw} alt="copy" className="logo-inner mb-0 me-2" />
            </div>
          </div>
        </div>
      </div>

      <div className="cards has-text-centered is-wide">
        <div className="card-second">
          <div className="text-padd">
            <h4 className="welcome-text">Welcome {name}</h4>
            {isVerify ? (
              <p className="wel-text-one">
                Please verify your identity before proceeding with onboarding.
              </p>
            ) : (
              <p className="wel-text-one">Please proceed with onboarding.</p>
            )}
            {isVerify && (
              <p className="otp-text">
                An OTP code will be sent to
                <span className="otp-no"> +1 XXX XXX {contact.substr(-4)}</span>
              </p>
            )}
          </div>
          <div className="text-center">
            {isVerify ? (
              <button
                type="button"
                className="otp-button"
                onClick={sendVerification}
              >
                Send OTP
              </button>
            ) : (
              <button
                type="button"
                className="otp-button"
                onClick={() => {
                  params?.tempid !== undefined
                    ? navigate(
                        "/candidateonboarding/" +
                          params.id +
                          "/" +
                          params.tempid
                      )
                    : navigate("/candidateonboarding/" + params.id);
                }}
              >
                Start Onboarding
              </button>
            )}
          </div>
        </div>

        <div className="line-border cardPost">
          <div className="need-text">
            <p className="message">
              <a href="#" className="">
                Need Help?
              </a>
            </p>
          </div>
        </div>
      </div>
      {/* for showing toast */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {loader && <Spinner />}
    </div>
  );
};
export default WelcomePage;
